import type { IconSvgObject } from './types';

const WifiConnected01Icon: IconSvgObject = [
  ["path", { d: "M4.18548 9.71764C9.10606 6.76079 14.8938 6.76079 19.8144 9.71764M8.82448 16.1185C10.8774 15.2938 13.1225 15.2938 15.1754 16.1185L21.009 8.06937C21.5813 7.27973 21.5097 6.17942 20.7487 5.56954C18.3521 3.64883 15.3102 2.5 12 2.5C8.6898 2.5 5.64792 3.64883 3.25132 5.56954C2.49034 6.17942 2.41868 7.27973 2.99097 8.06937L12 20.5M6.38421 12.7514C9.95294 11.0829 14.0469 11.0829 17.6157 12.7514", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 19L17 21.5L22 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WifiConnected01Icon;
